import * as Yup from "yup";
const StatesValidationSchema = (states) =>
  Yup.object({
    name: Yup.string()
      .trim()
      .required("College name is required")
      .test("duplicate-state", "This State already exists", function (value) {
        if (!value) return true;

        const stateNames = states
          // .filter((s) => s.id !== editId) // ignore edit case
          .map((s) => s.name.toLowerCase());

        return !stateNames.includes(value.toLowerCase());
      }),

    code: Yup.string().trim().required("College code is required"),

    image: Yup.string(),

    thumbnail: Yup.string(),
    active: Yup.string().required("Active is required"),
  });
const UniversitySchema = Yup.object().shape({
  name: Yup.string().trim().required("University Name is required"),

  code: Yup.string().trim().required("University Code is required"),

  // image: Yup.string()
  //   .required("Image is required"),

  // thumbnail: Yup.string()
  //   .required("Thumbnail is required"),

  stateId: Yup.string().required("State ID is required"),

  active: Yup.string().required("Active status is required"),

  viewable: Yup.string().required("Viewable status is required"),
});
const courseValidationSchema = (courses, id) =>
  Yup.object().shape({
    courseName: Yup.string().trim().required("Course name is required"),

    courseCode: Yup.string()
      .trim()
      .required("Course code is required")
      .max(10, "Maximum 10 characters allowed")
      .test(
        "duplicate-courseCode",
        "This Course code already exists",
        function (value) {
          if (!value) return true;
          const existingCodes = courses
            .filter((s) => s.id !== id)
            .map((s) => s.courseCode?.toLowerCase());
          return !existingCodes.includes(value.toLowerCase());
        },
      ),

    image: Yup.string().trim(),

    description: Yup.string().trim().required("Description is required"),

    // credits: Yup.number().required("Credits is required"),

    universityId: Yup.string().required("University is required"),

    noOfSemester: Yup.number().required("Number of semesters is required"),
    paymentType: Yup.string().required("Payment type is required"),
    active: Yup.string().required("Active status is required"),

    viewable: Yup.string().required("Viewable status is required"),

    semesters: Yup.array().required("Semesters are required"),

    category: Yup.string().trim().required("Category is required"),

    courseExtension: Yup.string().trim().required("Course extension is required"),

    mentorshipEnable: Yup.string().required("Mentorship enable is required"),
  });
const ReulationvalidationSchema = Yup.object({
  regulationName: Yup.string().required("Regulation name is required"),

  startYear: Yup.number().required("Start year is required"),

  endYear: Yup.number().required("End year is required"),

  description: Yup.string().required("Description is required"),

  order: Yup.number().required("Order is required"),

  courseIds: Yup.array().required("Course is required"),

  universityId: Yup.string().required("University is required"),

  active: Yup.string().required("Active is required"),

  customAttributes: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required("Key is required"),
        // val: Yup.string().required("Value is required"),
        description: Yup.string().nullable(),
      }),
    )
    .nullable()
    .notRequired(),
});
const SubjectvalidationSchema = Yup.object({
  name: Yup.string().required("Name is required"),

  displayOrder: Yup.number().required("Display order is required"),

  active: Yup.string()
    .oneOf(["true", "false"], "Invalid value")
    .required("Status is required"),
});
const LookupsvalidationSchema = Yup.object({
  lookup_value: Yup.string().required("Lookup value is required"),
});
const BankDetailsValidationSchema = Yup.object({
  accountHolderName: Yup.string().required("Account holder Name is required"),

  bankName: Yup.string().required("Bank name is required"),

  accountNumber: Yup.string()
    .matches(/^[0-9]{9,18}$/, "Account number must be 9–18 digits")
    .required("Account number is required"),

  ifscCode: Yup.string()
    .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC code")
    .required("IFSC code is required"),

  branchName: Yup.string().required("Branch name is required"),

  accountType: Yup.string().required("Account type is required"),
  experience: Yup.string().trim().required("Experience is required"),
});
const CourseCollegeValidationSchema = Yup.object({
  universityId: Yup.string().required("University is required"),

  courseId: Yup.string().required("Course is required"),

  active: Yup.string()
    .oneOf(["true", "false"], "Invalid value")
    .required("Active status is required"),
});
const PublicationsValidationSchema = Yup.object({
  name: Yup.string().trim().required("Name is required"),

  address: Yup.string().trim().required("Address is required"),

  website: Yup.string().trim().required("Website is required"),
});
const BlogValidationSchema = Yup.object({
  title: Yup.string().trim().required("Title is required"),

  category: Yup.string().trim().required("Category is required"),

  description: Yup.string().trim(),

  readTime: Yup.string().trim(),

  // Optional: a blog can be saved without a Content document (sent as "",
  // which the backend accepts). An uploaded document is still converted and
  // saved exactly as before.
  content: Yup.string(),

  // Topic-grouped shape: [{ topic, items: [{q, a}] }] -- see BlogModal.jsx's
  // normalizeFaqs/handleFaqDocxChange.
  faqs: Yup.array().of(
    Yup.object({
      topic: Yup.string().trim().nullable(),
      items: Yup.array().of(
        Yup.object({
          q: Yup.string().trim().required("Question is required"),
          a: Yup.string().trim().required("Answer is required"),
        }),
      ),
    }),
  ),

  published: Yup.string().required("Status is required"),
});
export default {
  StatesValidationSchema,
  UniversitySchema,
  courseValidationSchema,
  ReulationvalidationSchema,
  SubjectvalidationSchema,
  LookupsvalidationSchema,
  BankDetailsValidationSchema,
  CourseCollegeValidationSchema,
  PublicationsValidationSchema,
  BlogValidationSchema,
};
